<form #loginForm="ngForm" (ngSubmit)="createAccount(loginForm)">
    <div class="container-fluid">
      <h2 >Create Account</h2>   
      <br/>
      <input type="text" id="createusername" name="username" ngModel class="form-control" placeholder="Username" required autofocus>
      <br/>
      <input type="password" id="createpassword" name="password" ngModel class="form-control" placeholder="Password" required>
      <br/>
      <input type="password" id="createconfirmpassword" name="confirmpassword" ngModel class="form-control" placeholder="Confirm Password" required>
      <br />

      <div class="alert alert-danger alert-dismissible" *ngIf="invalidCreate">
        <button type="button" class="btn close h-100" data-dismiss="alert" (click)=dismiss()>&times;</button>
        {{message}}
      
        <button class="btn" 
                *ngIf="passproblem"
                ngbPopover="The password must be between 6 and 20 characters long and must contain at least one numeric digit, one uppercase and one lowercase letter"
                placement="bottom">
          <i class="fas fa-question-circle"></i>
        </button>
      </div>

      <button *ngIf="!startWaitingAnimation" class="btn btn-lg btn-primary btn-block" type="submit">Create</button>
      <div *ngIf="startWaitingAnimation" class="w-100 d-flex justify-content-center">
        <div class="spinner-border text-primary"></div>
      </div>

    </div>
  </form>